import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OpentokService } from "../_services/opentok.service";
import { Caption } from "../_models/models";
import Enumerable from "linq";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { OrganizationService, StreamBoxService } from "../_services/generatedServices";
import { ConferenceRoomViewModel } from "../_models/generatedModels";
import { ActivatedRoute } from "@angular/router";
import { SettingsProvider } from "../_services/settingsProvider.service";

@Component({
  selector: 'bxl-captions-display',
  templateUrl: 'captions-display.component.html',
})
export class CaptionsDisplayComponent implements OnInit {
  initialized = false;
  private session: OT.Session;
  captions: Caption[] = [];
  strCaptions: string [] = [''];
  strCaptionsDisplay: string[] = [];
  private lastFinalCaption: string = '';
  private allFinalizedText: string = ''; // Track all text that's been finalized
  private currentInterimCaption: string = ''; // Track the current interim being displayed
  private interimUpdateTimer: any;
  private lastInterimLength: number = 0;

  private lastInterimCaption: string = '';
  private captionDebounceTimer: any;


  currentIndex = 0;
  @ViewChild('card') private card: ElementRef;
  rooms: ConferenceRoomViewModel[];
  private conferenceSlug: string;
  public selectedRoom: number;
  fontSize: number = 20;
  private subscription: OT.Subscriber;


  constructor(private route: ActivatedRoute, public settingsProvider: SettingsProvider, private streamboxService: StreamBoxService, private openTokService: OpentokService, private organizationService: OrganizationService, private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((parentParam) => {
      this.conferenceSlug = parentParam.get('conferenceSlug');
      this.organizationService.getRoomsForConference(this.conferenceSlug).subscribe((result) => {
        this.rooms = Enumerable.from(result).where(x => x.channel != null).toArray();
        this.initialized = true;
      });
    });
  }

  public scrollToBottom(check: boolean): void {
    if (!this.card || !this.card.nativeElement) {
      return;
    }
    // Reduce delay since we want it to feel more responsive
    of(null)
      .pipe(delay(100))
      .subscribe((result) => {
        this.card.nativeElement?.scroll({
          top: this.card.nativeElement?.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
      });
  }

  public roomUpdated() {
    if (this.session) {
      this.session.off('streamCreated');
      this.session.unsubscribe(this.subscription);
      this.session.disconnect();
      this.session = null;
    }
    // Reset caption state when switching rooms
    this.strCaptions = [];
    this.strCaptionsDisplay = [];
    this.currentIndex = 0;
    this.lastFinalCaption = '';
    this.allFinalizedText = '';
    this.currentInterimCaption = '';
    this.lastInterimLength = 0;

    if (this.interimUpdateTimer) {
      clearTimeout(this.interimUpdateTimer);
      this.interimUpdateTimer = null;
    }

    console.log('room updated to: ' + this.selectedRoom);

    this.streamboxService.getStreamboxForRoomId(this.selectedRoom).subscribe((result) => {
      console.log("LOading captions for channel: " + result.azureChannel);
      this.InitOpenTok(result.id);
    });
  }

  private InitOpenTok(streamboxId: number) {
    this.openTokService
      .initsessionForStreamBoxCaptions(streamboxId)
      .then((session: OT.Session) => {
        this.session = session;
        this.session.on('streamCreated', (event) => {
          console.log('here');
          console.log(event.stream.name);
          console.log(event.stream.connection.data);

          this.subscription = this.session.subscribe(event.stream, 'videoCanvas', {
            insertMode: 'append',
            subscribeToAudio: false,
            subscribeToVideo: false,
            preferredResolution: {
              width: 1280,
              height: 720
            },
            style: {nameDisplayMode: 'off'},
          });
          this.subscription.element.hidden = true;

          this.subscription.subscribeToCaptions(true);
          this.subscription.on('captionReceived', (event) => {
            console.log(`Caption received for stream ${event.streamId}`);
            console.log(`Caption text: ${event.caption}`);
            console.log(`Final text: ${event.isFinal}`);
            console.log(`${event}`);

            const captionText = event.caption?.trim() || '';

            // Skip empty captions
            if (!captionText || event.isFinal) {
              return;
            }

            if (event.isFinal) {
              // Clear any pending interim updates
              if (this.interimUpdateTimer) {
                clearTimeout(this.interimUpdateTimer);
                this.interimUpdateTimer = null;
              }

              // Check if this exact caption was just added
              if (captionText === this.lastFinalCaption) {
                console.log('Skipping exact duplicate final caption');
                return;
              }

              // Check if this text is already contained in our finalized text
              if (this.allFinalizedText.includes(captionText)) {
                console.log('Skipping caption - already in finalized text');
                return;
              }

              // Check if the new caption overlaps with recently finalized text
              const lastTwoSentences = this.strCaptions.slice(-2).join(' ');
              if (lastTwoSentences.length > 20 && captionText.includes(lastTwoSentences.substring(lastTwoSentences.length - 20))) {
                console.log('Skipping overlapping caption block');
                return;
              }

              // Clear the interim caption since we're finalizing
              this.currentInterimCaption = '';
              this.lastInterimLength = 0;

              // Add the final caption to the array
              this.strCaptions.push(captionText);
              this.lastFinalCaption = captionText;

              // Keep a running record of all finalized text (last 500 chars to avoid memory issues)
              this.allFinalizedText = (this.allFinalizedText + ' ' + captionText).slice(-500);

              // Show ALL final captions (no interim since we just finalized)
              this.strCaptionsDisplay = [...this.strCaptions];

              this.scrollToBottom(true);
              this.ref.detectChanges();
            } else {
              // For interim captions, only show if they're meaningfully different

              const textChanged = this.currentInterimCaption !== captionText;

              if (!textChanged) {
                return; // Skip if it's the exact same interim text
              }

              // Calculate word count difference (more reliable than character count)
              const currentWordCount = this.currentInterimCaption.split(/\s+/).filter(w => w.length > 0).length;
              const newWordCount = captionText.split(/\s+/).filter(w => w.length > 0).length;

              // Only update if we've added at least 2 new words, OR if the length increased by 15+ chars
              const addedWords = newWordCount - currentWordCount;
              const lengthIncrease = captionText.length - this.lastInterimLength;

              const isSignificantAddition = addedWords >= 2 || lengthIncrease >= 15;

              // if (!isSignificantAddition && this.currentInterimCaption.length > 0) {
              //   console.log('Skipping minor correction:', {
              //     addedWords,
              //     lengthIncrease,
              //     old: this.currentInterimCaption,
              //     new: captionText
              //   });
              //   return;
              // }

              // Update the interim caption
              this.currentInterimCaption = captionText;
              this.lastInterimLength = captionText.length;

              // Clear any existing timer
              if (this.interimUpdateTimer) {
                clearTimeout(this.interimUpdateTimer);
              }

              // Debounce the UI update by 250ms to reduce flickering
              this.interimUpdateTimer = setTimeout(() => {
                // Show all final captions + current interim
                this.strCaptionsDisplay = [...this.strCaptions, this.currentInterimCaption];

                this.scrollToBottom(true);
                this.ref.detectChanges();
                this.interimUpdateTimer = null;
              }, 250);
            }

          }, this)
        });

      }).then(() => this.openTokService.connect())
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }

  public increaseFont() {
    this.fontSize += 5;
  }

  public decreaseFont() {
    this.fontSize -= 5;
  }


}
